import { render, staticRenderFns } from "./ReceiveRewardComponent.vue?vue&type=template&id=06cc8e0c&scoped=true"
import script from "./ReceiveRewardComponent.vue?vue&type=script&lang=js"
export * from "./ReceiveRewardComponent.vue?vue&type=script&lang=js"
import style0 from "./ReceiveRewardComponent.vue?vue&type=style&index=0&id=06cc8e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc8e0c",
  null
  
)

export default component.exports